import { useCallback } from 'react';
import { useHelpCenter } from './useHelpCenter.js';
import { HELP_CENTER_KEYS, SUPPORT_CENTER_KEYS } from '../types.js';
import { useLink } from './useLink.js';
import { render } from 'micromustache';

function useSupportCenter() {
  const getHelpCenter = useHelpCenter();
  const getLink = useLink();

  // Support center are divided between local links and zendesk links.
  // Until we find a better way of sorting this, this seems to be a good enough approach
  // https://packlink.atlassian.net/browse/PS-1220
  const getSupportCenterPage = useCallback(function (page) {
    let values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    function getSupportCenterLinkTemplate(page) {
      switch (page) {
        case SUPPORT_CENTER_KEYS.ticketLink:
          return getHelpCenter(HELP_CENTER_KEYS.ticketLink);
        default:
          return getLink(page) || getHelpCenter(HELP_CENTER_KEYS.home);
      }
    }
    const linkString = getSupportCenterLinkTemplate(page);
    return render(linkString, values);
  }, [getHelpCenter, getLink]);
  return getSupportCenterPage;
}

export { useSupportCenter };
//# sourceMappingURL=useSupportCenter.js.map
